export const dataIndustry = [
    { label: "Online Retail", value: "Online Retail" },
    { label: "Food and Beverage", value: "Food and Beverage" },
    { label: "Creative", value: "Creative" },
    { label: "Property", value: "Property" },
    { label: "Healthcare", value: "Healthcare" },
    { label: "Other Industry", value: "other" },
  ];